import { getEnv } from 'configs/env';
import capitalize from 'lodash/capitalize';
import {
  Button,
  CreateAlert,
  Icon,
  NumberUtils,
  ObjectUtils,
  Table,
} from 'modules';
import moment from 'moment';
import React, { FC, memo, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as XLSX from 'xlsx';

import {
  TableFilterInputText,
  TableFilterRangeTimeInput,
} from '../../../components/table-filter-inputs';
import { TableFilterInputSelect } from '../../../components/table-filter-inputs/select';
import { getLocaleKey, translate } from '../../../languages';
import { AdminService } from '../../../services/admin';
import { useSelector } from '../../../store';
import { transactionWrapper } from '../components';
const CopyToClipboardElement = CopyToClipboard as any;
export const PlaceGameList: FC<any> = transactionWrapper(
  memo(
    () => {
      const optionsTimeFilter = [
        { label: 'This Day', value: 'day' },
        { label: 'This Week', value: 'week' },
        { label: 'This Month', value: 'month' },
        { label: 'Custom', value: 'custom' },
      ];

      //const last1MothDate = Date.now() - 1000 * 60 * 60 * 24 * 30;

      const startOfMonth = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
      const endOfDay = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');

      const coinsState = useSelector((state) => state.coins);
      const coinsOptions = ObjectUtils.getIn(coinsState, 'data', [], (arr) =>
        arr.map((item: any) => ({
          label: item.name,
          value: item.coinId,
        })),
      );
      const UsdId = 2;
      const ButId = 5;
      const DemoId = 4;
      const Gp2Id = 5;

      const [currentData, setCurrentData] = useState(null as any);
      const [params, setParams] = useState<any>();
      const [forceUpdateTable, setForceUpdateTable] = useState<boolean>();
      const [isShowRangeTime, setIsShowRangeTime] = useState<boolean>(false);
      const [valueEmailFilter, setValueEmailFilter] = useState<any>();
      const [valueTimeFilter, setValueTimeFilter] = useState<any>();

      return (
        <div className='place-game-list'>
          <div className='button-container'>
            <Button
              disabled={!currentData}
              label='Export to Excel'
              buttonType='success'
              className='mb15'
              onClick={async () => {
                const response = await AdminService.getListTransactions({
                  ...params,
                  page: 1,
                  numberOfTransactionsPerPage: 1000000,
                  $ascs: 'created',
                });
                const data = [
                  ['Coin', 'Time', 'Email', 'Amount', 'Type'],
                  ...response.data.map((item: any) => {
                    const coin = coinsOptions.find(
                      (v: any) => v.value === item.coinId,
                    );
                    const { balanceAfter, balanceBefore } = item;
                    let isIncrease = false;
                    if (balanceAfter > balanceBefore) isIncrease = true;
                    const hash = ObjectUtils.getIn(item, 'transactionHash');
                    const row: any[] = [];
                    row.push(ObjectUtils.getIn(coin, 'label', '--'));
                    row.push(moment(item?.created).format('L LTS'));
                    row.push(item?.email);
                    row.push(
                      NumberUtils.toFormatNumber(
                        +item?.value,
                        +getEnv('NUMBER_DECIMAL_DISPLAY'),
                      ),
                    );
                    row.push(
                      ObjectUtils.getIn(
                        capitalize(
                          item.transactionType.name.replace(/_/g, ' '),
                        ),
                        '',
                        '--',
                      ),
                    );

                    return row;
                  }),
                ];

                const ws = XLSX.utils.aoa_to_sheet(data);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');

                const now = new Date();
                XLSX.writeFile(
                  wb,
                  `Place-Game-List-${now.toLocaleDateString().replace(/\//g, '-')} ${now
                    .toLocaleTimeString()
                    .replace(/:/g, '-')}.xlsx`,
                  { type: 'binary' },
                );
              }}
            />
          </div>
          <Table
            hasOrderColumn
            itemPerPages={10}
            filters={[
              {
                name: 'Email',
                key: 'email',
                input: (s) => (
                  <TableFilterInputText
                    {...s}
                    value={valueEmailFilter}
                    onChange={(e) => {
                      setValueEmailFilter(e?.email);
                      s.onChange(e);
                    }}
                  />
                ),
                defaultValue: valueEmailFilter,
              },
              {
                name: 'Time',
                key: 'time',
                input: (s) => (
                  <TableFilterInputSelect
                    {...s}
                    options={optionsTimeFilter}
                    value={valueTimeFilter}
                    onChange={(e) => {
                      setValueTimeFilter(e?.time);
                      s.onChange(e);
                      setForceUpdateTable((state) => !state);
                    }}
                    isClearable={true}
                  />
                ),
              },
              {
                name: '',
                key: 'created',
                input: (s) =>
                  isShowRangeTime ? (
                    <TableFilterRangeTimeInput
                      {...s}
                      fromKey='fromDate'
                      toKey='toDate'
                    />
                  ) : null,
              },
              // {
              //     name: "Amount",
              //     key: "amount",
              //     input: TableFilterInputNumber,
              // },
              // {
              //     name: translate("type"),
              //     key: "transactionTypeId",
              //     input: (s) => (
              //         <TableFilterInputSelect
              //             {...s}
              //             options={BankService.getTransactionTypeOptions().filter((item:any)=>item?.value===46)} //46 - place game
              //         />
              //     ),
              //     defaultValue: { label: "PLACE_GAME", value: 46 }
              // },
            ]}
            structure={[
              {
                name: 'Coin',
                key: 'coinId',
                className: 'coin',
                render: (item) => {
                  const coin = coinsOptions.find(
                    (v: any) => v.value === item.coinId,
                  );
                  let coinAvatar;
                  switch (coin?.value) {
                    case 3: {
                      coinAvatar = 'usd.png';
                      break;
                    }
                    case 5: {
                      coinAvatar = 'usdt.png';
                      break;
                    }
                  }
                  return (
                    <>
                      <img
                        className='coin-avatar'
                        src={`/assets/images/coins/${coinAvatar}`}
                        alt=''
                      />
                      <span className='coin-label'>
                        {ObjectUtils.getIn(coin, 'label', '--')}
                      </span>
                    </>
                  );
                },
              },
              {
                name: 'Time',
                key: 'created',
                render: (item) => {
                  const date = new Date(item.created);
                  return (
                    <span>
                      {date.toLocaleDateString(getLocaleKey())}{' '}
                      {date.toLocaleTimeString(getLocaleKey())}
                    </span>
                  );
                },
              },
              {
                name: 'Email',
                key: 'email',
                className: 'email',
                render: (item) => {
                  return (
                    <div>
                      <CopyToClipboardElement
                        text={item.email}
                        onCopy={() => {
                          CreateAlert({
                            message: translate('Copied'),
                            type: 'success',
                          });
                        }}
                      >
                        <div className='value'>
                          <span className='email'>{item.email}</span>
                          <span className='icon'>
                            <Icon.Copy />
                          </span>
                        </div>
                      </CopyToClipboardElement>
                    </div>
                  );
                },
              },
              {
                name: 'Amount',
                key: 'value',
                render: (item) => {
                  const { balanceAfter, balanceBefore } = item;
                  let isIncrease = false;
                  if (balanceAfter > balanceBefore) isIncrease = true;
                  return (
                    <span
                      className={
                        isIncrease ? 'positive-value' : 'negative-value'
                      }
                    >
                      {/* {isIncrease ? "+" : "-"} */}
                      {NumberUtils.toFormatNumber(
                        +item?.value,
                        +getEnv('NUMBER_DECIMAL_DISPLAY'),
                      )}
                    </span>
                  );
                },
              },
              {
                name: 'Type',
                key: 'transactionTypeId',
                render: (item) =>
                  ObjectUtils.getIn(
                    capitalize(item.transactionType.name.replace(/_/g, ' ')),
                    '',
                    '--',
                  ),
                //render: (item) => ObjectUtils.getIn(item, 'transactionType.name', '--'),
              },
              // {
              //     name: translate("description"),
              //     key: "description",
              // },
            ]}
            fetchData={async (params) => {
              setParams(params);

              if (params?.time === 'day') {
                params['fromDate'] = moment().startOf('day').toISOString();
                params['toDate'] = moment().endOf('day').toISOString();
                setIsShowRangeTime(false);
              }
              if (params?.time === 'week') {
                params['fromDate'] = moment().startOf('isoWeek').toISOString();
                params['toDate'] = moment().endOf('isoWeek').toISOString();
                setIsShowRangeTime(false);
              }
              if (params?.time === 'month') {
                params['fromDate'] = moment().startOf('month').toISOString();
                params['toDate'] = moment().endOf('month').toISOString();
                setIsShowRangeTime(false);
              }

              if (params?.time === '') {
                setIsShowRangeTime(false);
                delete params.fromDate;
                delete params.toDate;
              }

              if (params?.time === 'custom') {
                if (isShowRangeTime === false) {
                  delete params.fromDate;
                  delete params.toDate;
                }
                setIsShowRangeTime(true);
              }
              params['transactionTypeId'] = 46; //place-game

              return AdminService.getListTransactions({
                page: params.pageNumber,
                numberOfTransactionsPerPage: params.limit,
                ...params,
                $ascs: 'created',
              }).then((res) => {
                setCurrentData(res);
                return res;
              });
            }}
            forceUpdateTable={forceUpdateTable}
          />
        </div>
      );
    },
    () => true,
  ),
);
